import {
  Box,
  FormControl,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import languages from '../../../../../../helpers/utils/languages';

const PickUpAddress = ({
  formData,
  orderDetails,
  handleFormChange,
  formError,
}) => {
  const [isUsingOrderAddress, setIsUsingOrderAddress] = useState(true);

  const handleSwitchChange = (value) => {
    if (value) {
      handleFormChange({
        key: 'multipleFields',
        value: {
          address1: orderDetails.addresses.billing.line1,
          address2: orderDetails.addresses.billing.line2,
          postalCode: orderDetails.addresses.billing.postalCode,
          city: orderDetails.addresses.billing.city,
        },
      });
    }
    setIsUsingOrderAddress(value);
  };

  return (
    <Box sx={{ width: '100%', mt: 3 }}>
      <Typography
        color="primary"
        sx={{ fontSize: '1em', fontWeight: 'bold', mb: 1 }}
      >
        Adresse de l&apos;enlèvement
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
        <FormControlLabel
          control={
            <Switch
              checked={isUsingOrderAddress}
              onChange={(e) => handleSwitchChange(e.target.checked)}
            />
          }
          label="Identique à la commande"
        />
      </Box>
      {isUsingOrderAddress ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 0 }}>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Typography>
              <b>Adresse : </b>
              {formData.address1}
            </Typography>
          </Box>
          <Typography>
            <b>Complément d&apos;adresse : </b>
            {formData.address2}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Typography>
              <b>Code postal : </b>
              {formData.postalCode}
            </Typography>
            <Typography>
              <b>Ville : </b>
              {formData.city}
            </Typography>
            <Typography>
              <b>Pays : </b>
              {formData.country && (
                <>
                  <span
                    className={`fi fi-${formData.country.toLowerCase()}`}
                    style={{ marginRight: 8 }}
                  />
                  {languages.find(
                    (country) => country.code2 === formData.country
                  )?.country || ''}
                </>
              )}
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <TextField
            label="Adresse"
            value={formData.address1}
            onChange={(e) =>
              handleFormChange({ key: 'address1', value: e.target.value })
            }
            error={Boolean(formError.address1)}
            helperText={formError.address1}
            fullWidth
            size="small"
          />
          <TextField
            label="Complément d'adresse"
            value={formData.address2}
            onChange={(e) =>
              handleFormChange({ key: 'address2', value: e.target.value })
            }
            error={Boolean(formError.address2)}
            helperText={formError.address2}
            fullWidth
            size="small"
          />
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Code postal"
              value={formData.postalCode}
              onChange={(e) =>
                handleFormChange({ key: 'postalCode', value: e.target.value })
              }
              error={Boolean(formError.postalCode)}
              helperText={formError.postalCode}
              fullWidth
              size="small"
            />
            <TextField
              label="Ville"
              value={formData.city}
              onChange={(e) =>
                handleFormChange({ key: 'city', value: e.target.value })
              }
              error={Boolean(formError.city)}
              helperText={formError.city}
              fullWidth
              size="small"
            />
            <TextField
              disabled
              label="Pays"
              value={
                languages.find((country) => country.code2 === formData.country)
                  ?.country || ''
              }
              fullWidth
              size="small"
              slotProps={{
                input: {
                  startAdornment: formData.country && (
                    <span
                      className={`fi fi-${formData.country.toLowerCase()}`}
                      style={{ marginRight: 8 }}
                    ></span>
                  ),
                  readOnly: true,
                },
              }}
            />
          </Box>
        </Box>
      )}
      <FormControl
        error={Boolean(formError.additionalInfos)}
        fullWidth
        sx={{ mt: 2 }}
      >
        <Typography sx={{ fontSize: '0.8em' }}>
          Informations complémentaires
        </Typography>
        <TextField
          multiline
          rows={3}
          value={formData.additionalInfos}
          onChange={(e) =>
            handleFormChange({ key: 'additionalInfos', value: e.target.value })
          }
          placeholder="Renseignez des informations complémentaires pour l'enlèvement. (indications sur le lieu, code de sécurité, etc..)"
          error={Boolean(formError.additionalInfos)}
          helperText={formError.additionalInfos}
        />
      </FormControl>
    </Box>
  );
};

export default PickUpAddress;
